// A route only the VerityRx team can see.
//
// This is ROUTING, not authorization. Every operator endpoint refuses a
// non-admin on the server (dashboard/routers/operator.py, pinned by
// tests/test_operator_console.py); this guard exists so a customer or a
// reviewer who lands on an operator URL is sent home instead of shown a page
// full of 403s. It waits for the role to be known first — in prod the role
// arrives from /me after the token, and deciding on a not-yet-known role would
// bounce an admin off their own console on every reload.

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { CenterMessage, Spinner } from './ui';

export function AdminOnly({ children }: { children: ReactNode }) {
  const { isInternalAdmin, roleReady } = useAuth();
  if (!roleReady)
    return (
      <CenterMessage>
        <Spinner /> Loading…
      </CenterMessage>
    );
  if (!isInternalAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
